const PATIENT_FIELD_LABELS = {
  first_name: "First name",
  last_name: "Last name",
  gender: "Gender",
  date_of_birth: "Date of birth",
  client_id: "Client",
  project_id: "Project",
  email: "Email",
  phone: "Phone",
  address1: "Address line 1",
  city: "City",
  state: "State",
  zipcode: "Zip code",
  country: "Country",
  enrollment_date: "Enrollment date",
};

export function validatePatientForm(form, phoneFull, options = {}) {
  const { requireEmail = true, requireEnrollmentDate = false } = options;
  const errors = {};

  if (!form.first_name?.trim()) errors.first_name = "Required";
  if (!form.last_name?.trim()) errors.last_name = "Required";
  if (!form.gender) errors.gender = "Required";
  if (!form.date_of_birth) errors.date_of_birth = "Required";
  if (!form.client_id) errors.client_id = "Required";
  if (!form.project_id) errors.project_id = "Required";
  if (requireEmail && !form.email?.trim()) errors.email = "Required";
  if (!phoneFull?.trim() || !(form.phone_local || "").trim()) errors.phone = "Required";
  if (!form.address1?.trim()) errors.address1 = "Required";
  if (!form.city?.trim()) errors.city = "Required";
  if (!form.state?.trim()) errors.state = "Required";
  if (!form.zipcode?.trim()) errors.zipcode = "Required";
  if (!form.country) errors.country = "Required";
  if (requireEnrollmentDate && !form.enrollment_date) errors.enrollment_date = "Required";

  const missingLabels = Object.keys(errors).map((key) => PATIENT_FIELD_LABELS[key] || key);

  return {
    errors,
    missingLabels,
    isValid: missingLabels.length === 0,
  };
}

export function formatPatientValidationMessage(missingLabels) {
  if (!missingLabels.length) return "";
  if (missingLabels.length === 1) {
    return `Please enter ${missingLabels[0]}.`;
  }
  return `Please complete the following required fields: ${missingLabels.join(", ")}.`;
}

export function clearPatientFieldError(setFieldErrors, field) {
  setFieldErrors((prev) => {
    if (!prev[field]) return prev;
    const next = { ...prev };
    delete next[field];
    return next;
  });
}
